import { lazyWithErrorBoundary } from '../lib';

export const FinalizeStagePage = lazyWithErrorBoundary(
  () => import('@app/pages/finalize-stage'),
  'FinalizeStagePage',
);
export const SharingPage = lazyWithErrorBoundary(() => import('@app/pages/sharing'), 'SharingPage');
export const TextToSlidesPage = lazyWithErrorBoundary(
  () => import('@app/pages/text-to-slides'),
  'TextToSlidesPage',
);
export const TextToSlidesPreviewPage = lazyWithErrorBoundary(
  () => import('@app/pages/text-to-slides-preview'),
  'TextToSlidesPreviewPage',
);
export const NewChatPage = lazyWithErrorBoundary(
  () => import('@app/pages/new-chat'),
  'NewChatPage',
);
export const RegistrationPage = lazyWithErrorBoundary(
  () => import('@app/pages/registration'),
  'RegistrationPage',
);
export const LegalPage = lazyWithErrorBoundary(
  () => import('@app/pages/legal/legal.page'),
  'LegalPage',
);
export const TermsPage = lazyWithErrorBoundary(
  () => import('@app/pages/legal/terms.page'),
  'TermsPage',
);
export const PrivacyPage = lazyWithErrorBoundary(
  () => import('@app/pages/legal/privacy.page'),
  'PrivacyPage',
);
export const CookiePage = lazyWithErrorBoundary(
  () => import('@app/pages/legal/cookie.page'),
  'CookiePage',
);
export const FeaturesPage = lazyWithErrorBoundary(
  () => import('@app/pages/features/features.page'),
  'FeaturesPage',
);
export const AboutPage = lazyWithErrorBoundary(
  () => import('@app/pages/about/about.page'),
  'AboutPage',
);
export const PricingPage = lazyWithErrorBoundary(() => import('@app/pages/pricing'), 'PricingPage');
export const PasswordReset = lazyWithErrorBoundary(
  () => import('@app/auth/passwordReset.js'),
  'PasswordReset',
);
export const PasswordResetConfirm = lazyWithErrorBoundary(
  () => import('@app/auth/passwordResetConfirm.js'),
  'PasswordResetConfirm',
);
export const Error404Page = lazyWithErrorBoundary(
  () => import('@app/pages/error/error404.page'),
  'Error404Page',
);
export const CanvasDemoPage = lazyWithErrorBoundary(
  () => import('@app/pages/canvas-demo/canvas-demo.page'),
  'CanvasDemoPage',
);
export const ProjectsPage = lazyWithErrorBoundary(
  () => import('@app/pages/projects/projects.page'),
  'ProjectsPage',
);
export const SetupStylePage = lazyWithErrorBoundary(
  () => import('@app/pages/create/setup-style.page'),
  'SetupStylePage',
);
export const DomEditorPage = lazyWithErrorBoundary(
  () => import('@app/pages/dom-editor'),
  'DomEditorPage',
);
